import React from 'react'
import Navbar from '../../components/Navbar'
import StatsCard from '../../components/Support/StatsCard'
import TicketTable from '../../components/Support/TicketTable'

const Support = () => {
  // Dummy data
  const stats = [
    { title: 'Total Tickets', count: 10, trend: 'up', trendText: '1.3% Up from past week' },
    { title: 'In-Progress Tickets', count: 5, trend: 'up', trendText: '1.8% Up from yesterday' },
    { title: 'Resolved Tickets', count: 4, trend: 'down', trendText: '1.8% down from yesterday' },
    { title: 'Pending Tickets', count: 1, trend: 'down', trendText: '1.8% down from yesterday' },
  ]

  const tickets = [
    {
      id: '001',
      submittedBy: 'Vra Hospital',
      issueType: 'Billing',
      timestamp: '12-04-2024',
      priority: 'Low',
      status: 'Resolved'
    },
    {
      id: '002',
      submittedBy: 'Dr.Owusu',
      issueType: 'Technical',
      timestamp: '12-04-2024',
      priority: 'High',
      status: 'Not Resolved'
    },
    {
      id: '003',
      submittedBy: 'Dr.Mills',
      issueType: 'Technical',
      timestamp: '12-04-2024',
      priority: 'Medium',
      status: 'Pending'
    },
    {
      id: '004',
      submittedBy: 'Ridge Clinic',
      issueType: 'Billing',
      timestamp: '12-04-2024',
      priority: 'Medium',
      status: 'In-Progress'
    },
    // Add more dummy data as needed...
  ]

  return (
    <div>
      <Navbar page="Support" />
      <div className="min-h-screen bg-gray-50 p-6">
        <h1 className="text-2xl font-bold mb-6">Support Dashboard</h1>
        
        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {stats.map((stat, index) => (
            <StatsCard key={index} {...stat} />
          ))}
        </div>

        {/* Ticket Table */}
        <TicketTable tickets={tickets} />
      </div>
    </div>
  )
}

export default Support